// extracted by mini-css-extract-plugin
export default {"parsed":"Parsed_parsed__kTI4t"};